// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"4c146045","249":"328f4168","250":"536754ce","492":"c62abbac","773":"949e8f50","810":"7eb94e7e","962":"3a1b59a1"}[chunkId] + ".chunk.js";
};